import { gql } from '@apollo/client';

import {
  WITH_COUNT_VARIABLES,
  WITH_COUNT_ARGUMENTS
} from '../../queries/withCount';

const ERRORS = `errors { path, message }`;

const SETTING_FIELDS = `
  id
  storageFeeText
  lastPurchaseOrderNumber
  nextInvoiceNumber
  booksClosedOn
  processingFee
  featuredBlogLabel
  preReleaseResendDays
`;

const SETTING_VARIABLES = `
  $storageFeeText: String
  $lastPurchaseOrderNumber: Int
  $nextInvoiceNumber: Int
  $processingFee: Decimal
  $booksClosedOn: ISO8601Date
  $featuredBlogLabel: String
  $preReleaseResendDays: Int
`;

const SETTING_ARGUMENTS = `
  storageFeeText: $storageFeeText
  lastPurchaseOrderNumber: $lastPurchaseOrderNumber
  nextInvoiceNumber: $nextInvoiceNumber
  processingFee: $processingFee
  booksClosedOn: $booksClosedOn
  featuredBlogLabel: $featuredBlogLabel
  preReleaseResendDays: $preReleaseResendDays
`;

const SETTING_FIELDS_AND_ERRORS = `
  setting {
    ${SETTING_FIELDS}
  }
  ${ERRORS}
`;

export const UPDATE_SETTING = gql`
  mutation UpdateSetting(
    ${SETTING_VARIABLES}
  ) {
    updateSetting(
      ${SETTING_ARGUMENTS}
    ) {
      ${SETTING_FIELDS_AND_ERRORS}
    }
  }
`;

export const SETTING = gql`
  query SETTINGS {
    settings {
      ${SETTING_FIELDS}
    }
  }
`;

export const COLORS = gql`
  query Colors {
    colors {
      bg
      fg
    }
  }
`;
